export default function () {
	function findClosestElement(element, className) {
		while (element && !element.classList.contains(className)) {
			element = element.parentElement;
		}
		return element;
	}

	(function () {
		document.querySelectorAll('span.openMore').forEach(function (openMoreElement) {
			const toggleDetails = function () {
				const magazineNewsletterCont = findClosestElement(openMoreElement, 'magazineNewsletterCont');
				magazineNewsletterCont.querySelectorAll('.noteContDetail').forEach(function (noteContDetailElement) {
					const isHidden = noteContDetailElement.style.display === 'none';
					noteContDetailElement.style.display = isHidden ? 'block' : 'none';
					openMoreElement.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
				});
			};

			openMoreElement.addEventListener('click', toggleDetails);

			openMoreElement.addEventListener('keydown', function (event) {
				if (event.key === 'Enter') {
					event.preventDefault();
					toggleDetails();
				}
			});
		});
	})();

	(function () {
		document.querySelectorAll('.common-offers .item .benefitInOffers  ul li img.benefit-icon').forEach(item => {
			const closestEl = item.closest('.item').querySelector('.topBox h2 a');
			item.addEventListener('mouseover', event => {
				closestEl.classList.add('hovered');
			});
			item.addEventListener('mouseout', event => {
				closestEl.classList.remove('hovered');
			});
		});
	})();
}
